import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  padding: 10px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
`;

export const InputStyled = styled.input`
  border-width:0px;
  border:none;
  width: auto;
  font-size: 10px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  margin-left: 8px;
  padding: 4px;
  /* -webkit-appearance: none */
`;

export const Tags = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  
  width: auto;
  height: 20px;
  margin-left: 4px;
  margin-bottom: 4px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  border: 1px solid #EEEEEE; 
  border-radius: 10px;
  padding: 6px;

  img{
    width: 10px;
    margin-left: 3px;
    margin-right: 3px;

    :hover{
      opacity: 0.7; 
      cursor: pointer;
    }
  }
`;
